import styles from "./field.module.css";
import { ArrowIcon } from "..";
import onClickOutside from "react-onclickoutside";

export const SelectBox: view = ({
  values,
  currentValue,
  updateValue,
  isOpen,
  toggleOpen,
}) => {
  const currentLabel =
    values?.find((v) => v.value === currentValue)?.label || values[0].label;

  return (
    <div className={styles.dropdown}>
      <button
        className={styles.dropdownToggle}
        onClick={() => toggleOpen(!isOpen)}
      >
        <span>{currentLabel}</span>
        <ArrowIcon />
      </button>
      <DropdownMenuHOC
        values={values}
        isOpen={isOpen}
        currentValue={currentValue}
        closeMenu={() => toggleOpen(false)}
        updateValue={(value) => updateValue(value)}
      />
    </div>
  );
};

const DropdownMenu: any = ({
  values,
  isOpen,
  currentValue,
  updateValue,
  closeMenu,
}) => {
  DropdownMenu.handleClickOutside = () => closeMenu();
  return (
    <div className={`${styles.dropdownMenu} ${isOpen && styles.open}`}>
      {values
        .filter((v) => v.value !== currentValue)
        .map((x) => (
          <span
            className={`${styles.customOption} `}
            key={x.value}
            onClick={() => {
              updateValue(x.value);
              closeMenu();
            }}
          >
            {x.label}
          </span>
        ))}
    </div>
  );
};

const clickOutsideConfig = {
  handleClickOutside: () => DropdownMenu.handleClickOutside,
};

const DropdownMenuHOC = onClickOutside(DropdownMenu, clickOutsideConfig);
